import React from 'react';

const StatsBar = ({ userLevel, xp, streak }) => {
  return (
    <div className="px-6 mb-4">
      <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <div className="text-lg font-bold text-blue-400">Lv.{userLevel}</div>
            <div className="text-xs text-gray-300">等級</div>
          </div>
          <div>
            <div className="text-lg font-bold text-green-400">{xp}</div>
            <div className="text-xs text-gray-300">經驗值</div>
          </div>
          <div>
            <div className="text-lg font-bold text-purple-400">{streak}</div>
            <div className="text-xs text-gray-300">連擊</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsBar;
